module.exports = __webpack_public_path__ + "static/media/lato-bold.c2cdbb2f.woff";